
<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
export default {
    name: "UnitInfo__sensors_satelletes",
    extends: UnitInfo__sensors_default,
    computed:{
        title() {
            return this.$t('Unit.sensors.Satelletes')
        },
        value() {
            return this.unitLmsgSats
        },
        icon() {
            return this.showIcon ? false : false //ToDo need create icon
        }
    },
}
</script>

<style scoped>

</style>